import { useState, useEffect, ReactElement } from "react";
import { Button, DatePicker, Form, FormInstance, Input, Space, Spin, Typography } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { UserGroupContract } from "../../models/UserGroupContract";
import moment, { Moment } from "moment";

export type EditUserGroupContractFormProps = {
  form: FormInstance;
  userGroupContract: UserGroupContract,
};
export const EditUserGroupContractForm = ({form, userGroupContract}: EditUserGroupContractFormProps) => {

  console.log('mmm', userGroupContract.members);

  useEffect(() => {
    form.resetFields();
    form.setFieldsValue({
      'id': userGroupContract.id,
      'members': userGroupContract.members.map((m) => ({
        ...m,
        startDate: m.startDate !== null && m.startDate !== undefined ? moment(m.startDate) : null,
        endDate: m.endDate !== null && m.endDate !== undefined ? moment(m.endDate) : null,

        startDateDisabled: m.startDate !== null && m.startDate !== undefined ? m.startDate < new Date() : false,
        endDateDisabled: m.endDate !== null && m.endDate !== undefined ? m.endDate < new Date() : false,
      })),
    });
  }, [form, userGroupContract.id, userGroupContract.members]);

  const startDateM = !!userGroupContract.startDate ? moment(userGroupContract.startDate) : null;
  const endDateM = !!userGroupContract.endDate ? moment(userGroupContract.endDate) : null;

  const content = (
    <Form<UserGroupContract>
      form={form}
      style={{display: 'flex', flexDirection: 'column' }}
      layout="vertical"
    >
      <Form.Item noStyle name="id">
        <Input type="hidden" />
      </Form.Item>

      <section>
        <Form.List name="members">
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name, ...restField }, index) => (
                <div key={key}>
                  <div>Person {index + 1}</div>

                    <div style={{display: 'flex', flexDirection: 'row', justifyItems: 'stretch', gap: '8px'}}>
                      <Form.Item
                        {...restField}
                        label="Epostadress"
                        name={[name, 'username']}
                        style={{marginTop: -1}}
                        rules={[
                          {
                            required: true,
                            whitespace: true,
                            message: 'Ange en epostadress',
                          },
                          {
                            type: 'email',
                            message: 'Ange en giltig epostadress',
                          },
                        ]}
                      >
                        <Input maxLength={32} type="email" placeholder="namn@example.com" />
                      </Form.Item>
                      <Form.Item
                        name={[name, "startDate"]}
                        label="Inflytt"
                      >
                        <DatePicker
                          format="YYYY-MM-DD"
                          style={{ width: "100%" }}
                          allowClear={false}
                          disabled={form.getFieldValue([name, 'startDateDisabled'])}
                          disabledDate={(current: Moment): boolean => {
                            return !!startDateM && current.isBefore(startDateM, 'day');
                          }}
                        />
                      </Form.Item>
                      <Form.Item
                        name={[name, "endDate"]}
                        label="Utflytt"
                      >
                        <DatePicker
                          format="YYYY-MM-DD"
                          style={{ width: "100%" }}
                          allowClear={true}
                          disabled={form.getFieldValue([name, 'endDateDisabled'])}
                          disabledDate={(current: Moment): boolean => {
                            return !!endDateM && current.isAfter(endDateM, 'day');
                          }}
                        />
                      </Form.Item>
                      <Form.Item
                        label=" "
                      >
                        <Button
                          danger
                          onClick={(): void => remove(name)}
                          disabled={fields.length <= 1}
                        >
                          Ta bort
                        </Button>
                      </Form.Item>
                    </div>
                </div>
              ))}

              <div style={{display: 'flex', flexDirection: 'row', gap: 8}}>
                <Button
                  onClick={(): void => add({
                    username: '',
                    startDate: form.getFieldValue('startDate'),
                    endDate: form.getFieldValue('endDate'),
                  })}
                  //type="primary"
                >
                  Lägg till person
                </Button>
              </div>
            </>
          )}
        </Form.List>
      </section>
    </Form>
  );

  return content;
};


